module.exports = __webpack_public_path__ + "media/svg-new/icon-notificacoes-0fc9babe.svg";